import { html } from 'rune-ts';
import { preventEscape } from '../../../../util/preventEscape';
import { BaseDateButtonAction } from './BaseDateButtonAction.ts';
import { LaunchIcon } from '../../Icon/foundation_icons.ts';

export class ComingSoonButtonAction extends BaseDateButtonAction {
  protected override makeLabel() {
    const [days, hours, minutes, seconds] = BaseDateButtonAction.diff(this.data.end, this.data.start);
    return html`
      <b>${LaunchIcon()}</b>
      <div>
        <span data-is-coming-soon data-is-limited data-end="${this.data.end}" data-start="${this.data.start}">
          ${preventEscape(
            BaseDateButtonAction.convertLabel(
              { days, hours, minutes, seconds },
              { i18n: 'cta::remain_time_coming_soon' },
            ),
          )}
        </span>
        <span>${ET('cta::coming_soon')}</span>
      </div>
    `;
  }
}
